"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitialTableState = exports.useLocalStoragePersistor = void 0;
var react_1 = require("react");
var utils_1 = require("./utils");
var getTableId = function (tableId) { return "@newfront/table-".concat(tableId); };
function useLocalStoragePersistor(_a) {
    var tableId = _a.tableId;
    return function (hooks) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        hooks.useInstance.push(function (instance) { return useInstance(tableId, instance); });
    };
}
exports.useLocalStoragePersistor = useLocalStoragePersistor;
function useInitialTableState(_a) {
    var tableId = _a.tableId;
    return (0, react_1.useMemo)(function () {
        try {
            var storageKey = getTableId(tableId);
            return JSON.parse(localStorage.getItem(storageKey) || '{}');
        }
        catch (e) {
            return {};
        }
    }, [tableId]);
}
exports.useInitialTableState = useInitialTableState;
function useInstance(tableId, instance) {
    var state = instance.state;
    (0, utils_1.useDebouncedEffect)(function () {
        var storageKey = getTableId(tableId);
        localStorage.setItem(storageKey, JSON.stringify({
            columnResizing: state.columnResizing,
        }));
    }, [state.columnResizing], 500);
}
